// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// mui
import { ThemeProvider } from '@mui/material';

import Routes from 'routes';

import './App.css';
import { ConfigProvider } from 'contexts/ConfigContext';
import { AuthProvider } from 'contexts/AuthContext';
import { AspProvider } from 'contexts/AspContext';
import TagManager from 'react-gtm-module';
import Theme from 'utils/customThemes';

const sendPageView = (location: any) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'page_view',
      page: {
        url: window.location.href,
        path: location.pathname,
        title: document.title
      }
    }
  };
  TagManager.dataLayer(tagManagerArgs);
};

const PageViewHandler = () => {
  const location = useLocation();
  useEffect(() => {
    sendPageView(location);
  }, [location]);
  useEffect(() => {
    if (!location.pathname.startsWith('/rental/ec')) {
      // フォームのストレージ削除
      localStorage.removeItem('orderFormValues');
    }
  }, [location.pathname]);
  return null;
};

const App = () => {
  return (
    <ThemeProvider theme={Theme}>
      <ConfigProvider>
        <AuthProvider>
          <AspProvider>
            <PageViewHandler />
            <Routes />
          </AspProvider>
        </AuthProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default App;
